class QuickAddDropdown extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector('cart-drawer');
    this.button = this.querySelector('.product-card__quick-add-button');
    this.panel = this.querySelector('.product-card__quick-add-panel');
    this.list = this.querySelector('.product-card__quick-add-list');
    this.cartIcon = this.querySelector('.product-card__quick-add-icon--cart');
    this.checkIcon = this.querySelector('.product-card__quick-add-icon--check');
    this.revertTimeout = null;
    this.isAdding = false;

    this.button.addEventListener('click', this.toggle.bind(this));
    this.list.addEventListener('click', this.onOptionClick.bind(this));
    document.addEventListener('click', this.onOutsideClick.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  toggle(event) {
    event.stopPropagation();
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    document.querySelectorAll('quick-add-dropdown').forEach((el) => {
      if (el !== this) el.close();
    });
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return !this.panel.hidden;
  }

  onOutsideClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.button.focus();
    }
  }

  onOptionClick(event) {
    if (this.isAdding) return; // ignore clicks while a request is already in flight
    
    const option = event.target.closest('.product-card__quick-add-option');
    if (!option || option.classList.contains('product-card__quick-add-option--disabled')) return;

    const variantId = option.dataset.variantId;
    this.addToCart(variantId);
  }

  async addToCart(variantId) {
    this.isAdding = true;
    this.list.setAttribute('aria-disabled', 'true');

    try {
        const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (!addResponse.ok) throw new Error('Add to cart failed');

        const cartDrawerSection = document.querySelector('.shopify-section--cart-drawer');
        const sectionId = cartDrawerSection?.id.replace('shopify-section-', '');

        const cartUrl = sectionId
        ? `/cart.js?sections=${encodeURIComponent(sectionId)}`
        : '/cart.js';

        const cartResponse = await fetch(cartUrl);

        if (!cartResponse.ok) throw new Error('Failed to fetch updated cart');

        const cart = await cartResponse.json();

        this.close();
        this.showSuccess();

        const updated_cart = {...cart, sections: {
            sectionID: cartDrawerSection.outerHTML
        }};

        document.dispatchEvent(new CustomEvent('cart:change', { detail: { "cart": updated_cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
        console.error(error);
        // Optionally show an error state on the button here
    } finally {
        this.isAdding = false;
        this.list.removeAttribute('aria-disabled');
    }
  }

  showSuccess() {
    clearTimeout(this.revertTimeout);
    this.cartIcon.setAttribute("hidden", true);
    this.checkIcon.removeAttribute("hidden");
    this.cartDrawer?.show();

    this.revertTimeout = setTimeout(() => {
      this.cartIcon.removeAttribute("hidden");
      this.checkIcon.setAttribute("hidden", true);
    }, 3500);
  }
}

customElements.define('quick-add-dropdown', QuickAddDropdown);